module.exports = __webpack_public_path__ + "static/media/NotoSansArabic-Medium.2f8a7f1c.ttf";